import React from 'react';
import {
  AdUnitsOutlined,
  BadgeOutlined,
  BusinessOutlined,
  CodeOffRounded,
  FacebookOutlined,
  HomeOutlined,
  Instagram,
  InterestsOutlined,
  LinkedIn,
  LocalAtmRounded,
  LocationOnOutlined,
  LockOutlined,
  MailOutlineRounded,
  MonetizationOnOutlined,
  PeopleOutlined,
  PhoneOutlined,
  PublicRounded,
  RateReviewOutlined,
  ShowChartRounded,
  SouthAmericaRounded,
  StarOutline,
  StarRateRounded,
  StorefrontOutlined,
  ThumbUpOutlined,
  TrendingUpRounded,
  Twitter,
  WebhookRounded,
  WorkOutline,
  YouTube
} from '@mui/icons-material';
import { D7MetaKeys, LSMetaKeys } from '../params/prospect';

/**
 * Mapping of prospect metadata keys to descriptive Material-UI icons.
 */
export const iconMapping: Record<string, React.ReactNode> = {
  /* ------------------------------- D7META KEYS ------------------------------ */
  name: <BadgeOutlined fontSize="small" />,
  address1: <HomeOutlined fontSize="small" />,
  region: <SouthAmericaRounded fontSize="small" />,
  phone: <PhoneOutlined fontSize="small" />,
  email: <MailOutlineRounded fontSize="small" />,
  website: <PublicRounded fontSize="small" />,
  has_ssl: <LockOutlined fontSize="small" />,
  mobilefriendly: <AdUnitsOutlined fontSize="small" />,
  uses_wp: <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="22" viewBox="0,0,256,256">
    <g fill="#94a0b8" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: 'normal' }}><g transform="scale(8.53333,8.53333)"><path d="M15,3c-6.627,0 -12,5.373 -12,12c0,6.627 5.373,12 12,12c6.627,0 12,-5.373 12,-12c0,-6.627 -5.373,-12 -12,-12zM24.084,10.843c0.003,0.096 0.018,0.178 0.018,0.278c0,1.043 -0.196,2.217 -0.783,3.687l-2.987,8.637c-0.634,0.402 -1.315,0.732 -2.034,0.984l-3.116,-8.531l-2.991,8.692c-0.64,-0.188 -1.253,-0.437 -1.833,-0.742l-4.611,-12.627c0.271,-0.661 0.609,-1.286 1.008,-1.868c0.102,0.002 0.217,0.005 0.307,0.005c1.076,0 2.743,-0.131 2.743,-0.131c0.556,-0.031 0.62,0.783 0.066,0.849c0,0 -0.558,0.065 -1.178,0.098l3.748,11.151l2.252,-6.757l-1.602,-4.396c-0.556,-0.031 -1.08,-0.096 -1.08,-0.096c-0.556,-0.033 -0.489,-0.882 0.065,-0.849c0,0 1.7,0.131 2.71,0.131c1.076,0 2.743,-0.131 2.743,-0.131c0.556,-0.031 0.62,0.783 0.066,0.849c0,0 -0.559,0.065 -1.178,0.098l3.72,11.066l1.028,-3.434c0.522,-1.337 0.783,-2.444 0.783,-3.327c0,-1.272 -0.456,-2.153 -0.849,-2.838c-0.521,-0.849 -1.012,-1.566 -1.012,-2.415c0,-0.849 0.58,-1.64 1.431,-1.794c1.084,0.936 1.962,2.097 2.566,3.411z"></path></g></g>
  </svg>,
  uses_shopify: <StorefrontOutlined fontSize="small" />,
  facebook: <FacebookOutlined fontSize="small" />,
  fbpixel: <CodeOffRounded fontSize="small" />,
  instagram: <Instagram fontSize="small" />,
  ig_isbusiness: <Instagram fontSize="small" />,
  twitter: <Twitter fontSize="small" />,
  linkedin: <LinkedIn fontSize="small" />,
  lianalytics: <TrendingUpRounded fontSize="small" />,
  schema: <WebhookRounded fontSize="small" />,
  ganalytics: <ShowChartRounded fontSize="small" />,
  gremarketing: <LocalAtmRounded fontSize="small" />,

  /* ------------------------------- LSMETA KEYS ------------------------------ */
  address: <HomeOutlined fontSize="small" />,
  is_ssl: <LockOutlined fontSize="small" />,
  is_mobile_friendly: <AdUnitsOutlined fontSize="small" />,
  is_wordpress: <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="22" viewBox="0,0,256,256">
    <g fill="#94a0b8" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: 'normal' }}><g transform="scale(8.53333,8.53333)"><path d="M15,3c-6.627,0 -12,5.373 -12,12c0,6.627 5.373,12 12,12c6.627,0 12,-5.373 12,-12c0,-6.627 -5.373,-12 -12,-12zM24.084,10.843c0.003,0.096 0.018,0.178 0.018,0.278c0,1.043 -0.196,2.217 -0.783,3.687l-2.987,8.637c-0.634,0.402 -1.315,0.732 -2.034,0.984l-3.116,-8.531l-2.991,8.692c-0.64,-0.188 -1.253,-0.437 -1.833,-0.742l-4.611,-12.627c0.271,-0.661 0.609,-1.286 1.008,-1.868c0.102,0.002 0.217,0.005 0.307,0.005c1.076,0 2.743,-0.131 2.743,-0.131c0.556,-0.031 0.62,0.783 0.066,0.849c0,0 -0.558,0.065 -1.178,0.098l3.748,11.151l2.252,-6.757l-1.602,-4.396c-0.556,-0.031 -1.08,-0.096 -1.08,-0.096c-0.556,-0.033 -0.489,-0.882 0.065,-0.849c0,0 1.7,0.131 2.71,0.131c1.076,0 2.743,-0.131 2.743,-0.131c0.556,-0.031 0.62,0.783 0.066,0.849c0,0 -0.559,0.065 -1.178,0.098l3.72,11.066l1.028,-3.434c0.522,-1.337 0.783,-2.444 0.783,-3.327c0,-1.272 -0.456,-2.153 -0.849,-2.838c-0.521,-0.849 -1.012,-1.566 -1.012,-2.415c0,-0.849 0.58,-1.64 1.431,-1.794c1.084,0.936 1.962,2.097 2.566,3.411z"></path></g></g>
  </svg>,
  is_shopify: <StorefrontOutlined fontSize="small" />,
  fb_url: <FacebookOutlined fontSize="small" />,
  instagram_url: <Instagram fontSize="small" />,
  twitter_url: <Twitter fontSize="small" />,
  linkedin_url: <LinkedIn fontSize="small" />,
  html_found: <CodeOffRounded fontSize="small" />,
  is_ga: <ShowChartRounded fontSize="small" />,

  // Ratings & Reviews
  google_rating: <StarRateRounded fontSize="small" />,
  google_reviews: <RateReviewOutlined fontSize="small" />,
  yelp_rating: <StarRateRounded fontSize="small" />,
  yelp_reviews: <RateReviewOutlined fontSize="small" />,
  fb_rating: <StarRateRounded fontSize="small" />,
  fb_reviews: <RateReviewOutlined fontSize="small" />,
  fb_likes: <ThumbUpOutlined fontSize="small" />,

  // Advertising Platforms
  is_adwords: <MonetizationOnOutlined fontSize="small" />,
  is_facebook_ads: <FacebookOutlined fontSize="small" />,
  is_twitter_ads: <Twitter fontSize="small" />,
  is_linkedin_ads: <LinkedIn fontSize="small" />,
  is_bing_ads: <PublicRounded fontSize="small" />,

  // External Links
  youtube_url: <YouTube fontSize="small" />,
  pinterest_url: <InterestsOutlined fontSize="small" />,
  tripadvisor_url: <LocationOnOutlined fontSize="small" />,

  // TripAdvisor Stats
  tripadvisor_rating: <StarRateRounded fontSize="small" />,
  tripadvisor_reviews: <RateReviewOutlined fontSize="small" />,

  // Bing Metrics
  bing_rating: <StarRateRounded fontSize="small" />,
  bing_reviews: <RateReviewOutlined fontSize="small" />,

  // Claims & Rankings
  google_claim: <StarOutline fontSize="small" />,
  bing_rank: <TrendingUpRounded fontSize="small" />,
  fb_rank: <TrendingUpRounded fontSize="small" />,
  google_rank: <TrendingUpRounded fontSize="small" />,
  google_places_rank: <TrendingUpRounded fontSize="small" />,
  yelp_rank: <TrendingUpRounded fontSize="small" />,

  // Company Info
  company_size: <BusinessOutlined fontSize="small" />,
  employees: <PeopleOutlined fontSize="small" />,
  hiring: <WorkOutline fontSize="small" />
};

/**
 * Returns the appropriate icon for a given metadata label.
 */
export const getIconByLabel = (label: D7MetaKeys | LSMetaKeys): React.ReactNode => {
  return iconMapping[label] || null;
};
